// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"440":"8019f62ec5b60be87c22","581":"4bd961378b48e6c6a46f"}[chunkId] + ".js";
};